import { Injectable, signal } from '@angular/core';
import { ServiceNode } from '../types/service-node';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { UriApi } from '../helpers/UriApi';

@Injectable({
  providedIn: 'root',
})
export class ServiceManagementService {
  constructor(private http: HttpClient, private router: Router) { }
  body = {
    request: {
      jsonParams: {},
      data: "",
      dataList: "",
      menuCd: ''
    }
  };

  getService(param: any = {}) {
    this.body.request.jsonParams = param;
    return this.http.post(UriApi.api_Service_Get, this.body)
  }

  post(param : any = {}){
    this.body.request.jsonParams = param;
    return this.http.post(UriApi.api_Service_Post, this.body)
  }

  // private MOCK_OPTION_TREE: ServiceNode[] = [
  //   {
  //     id: 'og1', name: '스파/팩', type: 'GROUP', usage: 'Use', children: [
  //       {
  //         id: 'oc1', name: '스파', type: 'CATEGORY', usage: 'Use', children: [
  //           { id: 'op1', name: '머드 스파', type: 'PRODUCT', price: 15000, time: 20, usage: 'Use' },
  //           { id: 'op2', name: '탄산 스파', type: 'PRODUCT', price: 20000, time: 20, usage: 'Use' },
  //           { id: 'op3', name: '아로마 스파', type: 'PRODUCT', price: 25000, time: 30, usage: 'Use' },
  //         ]
  //       },
  //       {
  //         id: 'oc2', name: '팩', type: 'CATEGORY', usage: 'Use', children: [
  //           { id: 'op4', name: '허브 팩', type: 'PRODUCT', price: 10000, time: 15, usage: 'Use' },
  //         ]
  //       },
  //     ]
  //   },
  //   {
  //     id: 'og2', name: '염색', type: 'GROUP', usage: 'Use', children: [
  //       {
  //         id: 'oc3', name: '부분 염색', type: 'CATEGORY', usage: 'Use', children: [
  //           { id: 'op5', name: '귀 염색', type: 'PRODUCT', price: 5000, time: 10, usage: 'Use' },
  //           { id: 'op6', name: '꼬리 염색', type: 'PRODUCT', price: 5000, time: 10, usage: 'Use' },
  //         ]
  //       },
  //       { id: 'oc4', name: '전체 염색', type: 'CATEGORY', usage: 'Unused', children: [] }
  //     ]
  //   }
  // ];

  // getOptionTree() {
  //   return signal(this.MOCK_OPTION_TREE);
  // }

  getServiceTree() {

    return signal<ServiceNode[]>([]);
  }
}
